import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '../layout/MainLayout.vue'
import LoginView from '../views/auth/LoginView.vue'
import RegisterView from '../views/auth/RegisterView.vue'
import DiagnosisRecords from '../views/DiagnosisRecords.vue'
import OpenDiagnosisRecords from '../views/OpenDiagnosisRecords.vue'
import StartDiagnosis from '../views/StartDiagnosis.vue'
import SpecializedDiagnosis from '../views/SpecializedDiagnosis.vue'
import PatientManagement from '../views/PatientManagement.vue'
import UserProfile from '../views/UserProfile.vue'

import HomeView from '../views/HomeView.vue'
import PatientHome from '../views/patient/PatientHome.vue'
import PatientDiagnosisRecords from '../views/patient/PatientDiagnosisRecords.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/patient',
    name: 'PatientHome',
    component: PatientHome
  },
  {
    path: '/patient/records',
    name: 'PatientDiagnosisRecords',
    component: PatientDiagnosisRecords
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView
  },
  {
    path: '/doctor',
    component: MainLayout,
    redirect: '/doctor/specialized',
    children: [
      {
        path: 'start',
        name: 'StartDiagnosis',
        component: StartDiagnosis
      },
      {
        path: 'specialized',
        name: 'SpecializedDiagnosis',
        component: SpecializedDiagnosis
      },
      {
        path: 'records',
        name: 'DiagnosisRecords',
        component: DiagnosisRecords
      },
      {
        path: 'open-records',
        name: 'OpenDiagnosisRecords',
        component: OpenDiagnosisRecords
      },
      {
        path: 'patients',
        name: 'PatientManagement',
        component: PatientManagement
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: UserProfile
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const publicPaths = ['/login', '/register', '/', '/patient', '/patient/records']
  if (publicPaths.includes(to.path)) {
    next()
    return
  }
  let token = null
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      token = window.localStorage.getItem('token')
    }
  } catch (e) {
    token = null
  }
  if (!token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
